import BasicList from '../BasicList';
import {get} from '../../utils/fetch';
import { backendServer } from '../../variable';

/**
 * listItem 数据模型:
 * {
 *  username: string // 系统申请用户名
 *  createdAt: string // 开票时间
 *  title: string	// 发票抬头
 *  taxNumber: string // 税号
 *  amount: number //单位分,金额,用于判断前后端金额是否对等
 *  addresseeName: string	// 收件人名称
 *  addresseePhone: string	// 收件人手机号码
 *  addresseeAddress: string	// 收件人地址
 *  extraRegisterAddress: string	// 注册地址
 *  extraRegisterPhone: string	// 注册电话
 *  extraBankAccount: string	// 银行账号
 *  extraBankName: string // 开户行
 *  extraNote: string	// 备注
 * }
 */
const requestList = async ({page, pageSize, ...params}) => {
  try {
    const result = await get(`${backendServer}/agent/invoice/list`, {
      page,
      pageSize,
      ...params
    });
    return result;
  } catch (e) {
    throw e;
  }
};

// 出售记录列表
const ticketList = new BasicList(requestList);
ticketList.setListName('开票记录');

export default ticketList;


// WEBPACK FOOTER //
// ./src/stores/ticketList/index.js